import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-difference',
  templateUrl: './difference.component.html',
  styleUrls: ['./difference.component.css', './../home.component.css']
})
export class DifferenceComponent implements OnInit {

  shopUrl = environment.shopUrl;
  
  constructor() { }

  ngOnInit(): void {
  }

}
